import Component from "../../lib/component";
import {SelecterItem, SelecterItemConfig} from "./selecter_item";
import {SelecterFilter, SelecterFilterConfig} from "./selecter_filter";
import {SelecterFilterInfo} from "./selecter_filter_info";
import {SelecterItemsInfo} from "./selecter_items_info";

// TODO - change all classes in the views to use a HTML class like "selecter" rather then "selector".
export const SelecterConfig = {
    componentTypeKey: 'Selecter',
    baseHtmlClass: 'selector',
    selector: '.selector',

    datasetConfigKey: 'selecter__config',
    selectionModeDatasetKey: 'selection_mode',

    oneSelectionModeKey: 'one',
    manySelectionModeKey: 'many',

    itemsThresholdForFilter: 12,
    itemsThresholdForItemsInfo: 10,

    headerBaseHtmlClass: 'selector__header',
    itemsSelector: '.selector__items',
};

export class Selecter extends Component {

    static createHeaderElement() {
        let element = document.createElement('div');
        element.classList.add(SelecterConfig.headerBaseHtmlClass);
        return element;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: SelecterConfig
        });

        this.config = this.getDatasetConfig();


        this.selectionMode = this.getSelectionModeConfig();

        this.selecterItems = [];
        this.element.querySelectorAll(SelecterItemConfig.selector).forEach((element) => {
            this.selecterItems.push(new SelecterItem(element, this));
        });

        this.handleEvent(SelecterItemConfig.changedEventName, this.handleItemChanged.bind(this));
        this.handleEvent(SelecterFilterConfig.changedQueryEventName, this.handleQueryChanged.bind(this));

        this.searchQuery = null;

        // Add the header for the filter and items info.
        this.headerElement = Selecter.createHeaderElement();

        // Add the ItemsInfo component
        if (this.requiresItemsInfo()) {
            let itemsInfoElement = SelecterItemsInfo.createElement();
            this.headerElement.insertBefore(itemsInfoElement, this.headerElement.firstChild);
            this.selecterItemsInfo = new SelecterItemsInfo(itemsInfoElement, this);
        }

        // Add the Filter component
        if (this.requiresFilter()) {
            let filterElement = SelecterFilter.createElement();
            this.headerElement.insertBefore(filterElement, this.headerElement.firstChild);
            this.selecterFilter = new SelecterFilter(filterElement, this);

            let filterInfoElement = SelecterFilterInfo.createElement();
            filterElement.insertBefore(filterInfoElement, null);
            this.selecterFilterInfo = new SelecterFilterInfo(filterInfoElement, this);
        }

        if (this.selecterItemsInfo || this.selecterFilter || this.selecterFilterInfo) {
            this.element.insertBefore(this.headerElement, this.element.firstChild);
        }

        this.render();
    }

    handleItemChanged(componentEvent) {
        this.render();
    }

    handleQueryChanged(componentEvent) {
        this.searchQuery = componentEvent.memo['query'];
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.selectionMode === SelecterConfig.oneSelectionModeKey, `select_${SelecterConfig.oneSelectionModeKey}`);
        this.conditionallySetHtmlClassState(this.selectionMode === SelecterConfig.manySelectionModeKey, `select_${SelecterConfig.manySelectionModeKey}`);
        if (this.selecterFilter) this.selecterFilter.render();
        if (this.selecterFilterInfo) this.selecterFilterInfo.render();
        this.selecterItems.forEach((selecterItem) => {
            selecterItem.render()
        });
        if (this.selecterItemsInfo) this.selecterItemsInfo.render();
    }

    requiresFilter() {
        return this.selecterItems.length > SelecterConfig.itemsThresholdForFilter;
    }

    requiresItemsInfo() {
        if (this.requiresFilter()) return true;
        if (this.selectionMode === SelecterConfig.oneSelectionModeKey) return false;
        return this.selecterItems.length > SelecterConfig.itemsThresholdForItemsInfo;
    }

    getSearchQuery() {
        return this.searchQuery;
    }

    matchedSelecterItems() {
        return this.selecterItems.filter(selecterItem => selecterItem.matchesSearchQuery(this.getSearchQuery()));
    }

    selectedItems() {
        return this.selecterItems.filter(selecterItem => selecterItem.isSelected());
    }

    getTotalItemsCount() {
        return this.selecterItems.length;
    }

    getMatchedItemsCount() {
        return this.matchedSelecterItems().length;
    }

    getSelectionModeConfig() {
        return this.getDatasetConfigSelectionMode() || this.getImpliedSelectionModeConfig() || SelecterConfig.manySelectionModeKey;
    }

    getDatasetConfigSelectionMode() {
        let datasetMode = this.config[SelecterConfig.selectionModeDatasetKey];
        if (datasetMode === SelecterConfig.oneSelectionModeKey) return SelecterConfig.oneSelectionModeKey;
        if (datasetMode === SelecterConfig.manySelectionModeKey) return SelecterConfig.manySelectionModeKey;
    }

    // If it's a radio button then it means "one" can be selected. Otherwise we default to "many".
    getImpliedSelectionModeConfig() {
        let firstItemInput = this.element.querySelector(SelecterItemConfig.inputSelector);
        if (!firstItemInput) return;
        if (firstItemInput.type === 'radio') return SelecterConfig.oneSelectionModeKey;
        if (firstItemInput.type === 'checkbox') return SelecterConfig.manySelectionModeKey;
    }
}

